<template>
  <ClosedZoneForm />
</template>

<script>
import ClosedZoneForm from './components/closed-zone/ClosedZoneForm.vue'

export default {
  components: {
    ClosedZoneForm,
  },
}
</script>

<style>

</style>
